import service from '@/services/roles'
const namespaced = true
const state = {
  rolesList: []
}
const getters = {
  getRolesList: state => state.rolesList
}
const actions = {
  async loadRoles({ commit }) {
    const response = await service.getList()
    if (response?.data?.error?.type === 200) {
      commit('setRolesList', response.data.data.map(item => {
        item.selected = false
        return item
      }))
    }
  },
  addNewRole: ({ commit }, payload) => {
    commit('addRoleToList', payload)
  },
  deleteRole: ({ commit }, payload) => {
    payload.forEach(item => {
      commit('deleteRoleOfList', item)
    })
  }
}
const mutations = {
  setRolesList(state, payload) {
    state.rolesList = payload
  },
  addRoleToList(state, payload) {
    state.rolesList.push(payload)
  },
  deleteRoleOfList(state, payload) {
    const itemIndex = state.rolesList.findIndex(item => item.id === payload.id)
    if (itemIndex >= 0) state.rolesList.splice(itemIndex, 1)
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
